define('views/user/register/financial/success',[
    "backbone",
    "text!views/user/register/financial/success.html",
    "views/_base/baseview",
    "models/accounts/account"
], function (Backbone, Template, BaseView, Account) {
    "use strict";

    return BaseView.extend({
        isRender: true,
        needsAuth: true,
        template: _.template(Template),
        events: {
            "click #cancelWays": "cancelWays",
            "click #btnLinkBankAccount": "showWays",
            "click #btnDirectDeposit": "showDirectdeposit"
        },
        tagName: "section",
        id: "financialRegSuccess",

        initialize: function (options) {
            options = options || {};
            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },

        render: function () {
            this.$el.html(this.template({}));
            this.$("#btnLinkBankAccount").attr('disabled', true);
            pf.session.getAuth(function () { });
            this.getLinkedBankAccount();

            $(window).scrollTop(0);

            return this;
        },

        getLinkedBankAccount: function(){
            var that = this;
            var account = new Account({ instanceURL: pf.consumerURL + "/LinkedBankAccount" });
            account.fetch({
                success: function (resp, model) {
                    if (!model || !model.BA || !model.BA.EFID)         //bank account does not exist
                        that.$("#btnLinkBankAccount").attr('disabled', false);
                },
            })
        },

        showWays: function(e) {
            //alert(pf.session.get('linkedBankAccount'));
            this.$("#btnLinkBankAccount").attr('disabled', true);
            this.$("#btnLinkBankAccount").addClass("btn-showSpinner");
        },

        showDirectdeposit: function () {
            this.$("#btnDirectDeposit").attr('disabled', true);
            this.$("#btnDirectDeposit").addClass("btn-showSpinner");

            pf.require("views/user/directdeposit/directdeposit", null, null, true, function () {
                require(["views/user/directdeposit/directdeposit"], function (DirectDepositView) {
                    pf.show(new DirectDepositView({ elementName: "#contentRegion" }));
                });
            });

        },

        cancelWays:function(e){
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            pf.navigate("#merchants");
            this.cleanup();
        },

        close: function () { }
    });
});

